<template>
  <div>
    <div class="white-container" :key="$store.getters['resource/currentResource'].key">
      <event-view @save="saveEvent"/>
    </div>
  </div>
</template>

<script>
  import EventView from "./EventView.vue";

  export default {
    components: {
      EventView
    },
    middleware: 'auth',
    name: 'EventEditing',
    methods: {
      saveEvent(params) {
        this.postData('events/handlers', params, '/actions');
      }
    }
  }
</script>